<template>
  <span style="cursor: pointer;" @click="changeTheme">
    <img v-if="darkMode" alt="sun" src="../assets/sun.png" />
    <img v-else alt="moon" src="../assets/moon.png" />
  </span>
</template>

<script>
export default {
  name: "themeSwitch",
  data() {
    return {
      darkMode: false
    }
  },
  mounted() {
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }
  },
  watch: {
    darkMode: function () {
      let htmlElement = document.documentElement;

      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
  },
  methods: {
    changeTheme() {
      this.darkMode = !this.darkMode;
    }
  }
}
</script>

<style scoped>
img {
  height: 25px;
  margin-right: 10px;
}
</style>
